/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button } from "@mui/material";
import { useFormState } from "cms/forms/context/hooks/use-form-state";
import { useForm } from "cms/forms/context";
import { SVGIcons } from "cms/icons/svg-icons";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { isStringNotEmpty } from "utils/empty-exists";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faRepeat } from "@fortawesome/pro-regular-svg-icons";

const Message = (props) => {
    
    const form_id = props?.form_id;
    const setExistingFormsDialogOpen = props?.setExistingFormsDialogOpen;
    // const setCreateDialogOpen = props?.setCreateDialogOpen;
    // const setCreateFormFlowDialogOpen = props?.setCreateFormFlowDialogOpen;
    
    const { t } = useTranslation();
    const { loadCurrentSchemaForm } = useForm();
    const { form } = useFormState();
    const name = form?.name;
    const type = form?.type;
    
    const hasFormGuid = useMemo(() => {
        return isStringNotEmpty(form_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form_id]);

    const hasName = useMemo(() => {
        return isStringNotEmpty(name);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name]);

    useEffect(() => {
        if (hasFormGuid) {
            loadCurrentSchemaForm(form_id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form_id]);
    
    const handleFindExistingForm = () => {
        setExistingFormsDialogOpen(true);
    };

    return (
        <div className='simplicity-composer-embed'>
            <div className='simplicity-form-composer-container'>
                {(!hasName || !hasFormGuid) &&
                    <Button color='primary' variant='contained' onClick={handleFindExistingForm}>
                        <SVGIcons.common.Create style={{ marginRight: "8px" }} />
                        {t("commons.selectForm")}
                    </Button>
                }
                <div className='simplicity-form-composer-select-form'>
                    {(hasName && hasFormGuid) &&
                        <div className="form-actions">
                            <div className="actions-container">
                                <span className="form-name">{name}</span>
                                <NavLink 
                                    to={`/forms/${type}/build/${form_id}`}
                                    target="_self"
                                >
                                    <Button
                                        startIcon={<FontAwesomeIcon icon={faPenToSquare} />}
                                        size="small"
                                        className="edit-form-button"
                                    >
                                        {t("Forms.editThisForm")}
                                    </Button>
                                </NavLink>
                            </div>
                            <Button
                                size="small"
                                name="Change"
                                variant="outlined"
                                color="neutral"
                                startIcon={<FontAwesomeIcon icon={faRepeat} color='#7A7A7A'/>}
                                className="change-button"
                                onClick={handleFindExistingForm}
                            >
                                Change
                            </Button>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};
export default Message;
